import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, Spinner } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, CardHeader, Input } from 'reactstrap';
import axios from 'axios';
import config from '../../../../../config';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';

const REPORT_COLUMNS = [
    { label: 'Tenant Name', key: 'tenant_name' },
    { label: 'Tenant Code', key: 'tenant_code' },
    { label: 'Outlet Code', key: 'outlet_code' },
    { label: 'Property', key: 'property_name' },
    { label: 'Audit Period', key: 'audit_period' },

    { label: 'EGoal Gross', key: 'egoal_gross_value', format: 'number' },
    { label: 'EGoal Tax', key: 'egoal_tax_value', format: 'number' },
    { label: 'EGoal Net Sales', key: 'egoal_netsales_value', format: 'number' },

    { label: 'Store Gross', key: 'store_gross_value', format: 'number' },
    { label: 'Store Tax', key: 'store_tax_value', format: 'number' },
    { label: 'Store Net Sales', key: 'store_netsales_value', format: 'number' },
    { label: 'Store Discount', key: 'store_discount_value', format: 'number' },
    { label: 'Store Returns', key: 'store_return_value', format: 'number' },

    { label: 'Difference Gross', key: 'difference_gross', format: 'number' },
    { label: 'Difference Tax', key: 'difference_tax', format: 'number' },
    { label: 'Difference Net Sales', key: 'difference_netsales', format: 'number' },

    { label: 'Status', key: 'audit_status' },
    { label: 'Comments', key: 'audit_comments' },
    { label: 'Discrepancy Remarks', key: 'discrepancy_remarks' }
];

const TenantAuditReportView = () => {

    if (localStorage.getItem("accessReports") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const getYesterdayDate = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    };

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const [startDate, setStartDate] = useState(getYesterdayDate());
    const [endDate, setEndDate] = useState(getYesterdayDate());
    const [properties, setProperties] = useState([]);
    const [categories, setCategories] = useState([]);
    const [group_name, setGroupName] = useState('');
    const [subcategories, setSubcategories] = useState([]);
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [allFloors, setAllFloors] = useState([]);
    const [floors, setFloors] = useState([]);
    const [property_id, setPropertyId] = useState('');
    const [category_id, setCategoryId] = useState('');
    const [subcategory_id, setSubcategoryId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [selectedFloor, setSelectedFloor] = useState('');
    const [ReportData, setReportData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(50);
    const [validationMessage, setValidationMessage] = useState('');
    const [loading, setLoading] = useState(false)
    const today = new Date().toISOString().split('T')[0];
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const [tooltip, setTooltip] = useState('');

    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const [selectedTenants, setSelectedTenants] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [searchTenant, setSearchTenant] = useState('');
    const [monthError, setMonthError] = useState('');
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };


    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    // 🔽 Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
                const propertyNames = response.data.map(property => property.property_name).join(',');
                setPropertyAccesssNames(propertyNames);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);



    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;

        if (group_name !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_group_name === group_name);
        }

        if (category_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_category_id._id === category_id);
        }

        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        if (subcategory_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_subcategory_id._id === subcategory_id);
        }

        setTenants(filteredTenants);
    }, [group_name, property_id, category_id, subcategory_id, allTenants]);


    const filteredTenants = tenants.filter((tenant) => {
        if (!searchTenant.trim()) return true;

        const search = searchTenant.trim().toLowerCase();

        const name = (tenant.tenant_store_name || "").toLowerCase();
        const code = (tenant.tenant_code || "").toLowerCase(); // or tenant.tenant_code / tenant_code

        return name.includes(search) || code.includes(search);
    });

    const generateReport = async (e) => {
        e.preventDefault();

        if (!selectedMonth) {
            setMonthError("Select an audit period");
            return;
        }

        const data = {
            concessionaire_id,
            year: getYear(),
            month: getMonth(),
            property_access: propertyAccessNames,
            property_id: property_id || null,
            tenant_id: selectedTenants,
        };

        setLoading(true)
        axios
            .post(`${config.hostname}/reports/gettenantauditreport`, data, configheader)
            .then((response) => {
                const data = response.data || [];
                setReportData(data);
                setLoading(false)
                insertToLog(" generated Audit Detailed report")
                console.log(response.data);
            })
            .catch((error) => {
                setLoading(false)
                console.log(error);
                if (error.response && error.response.status !== 404) {
                    toast.error("Server error");
                }
            });
    };

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Reports",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {
                toast.error('Error')
                console.log(error);

            });
    }

    const handlePropertyChange = (e) => {
        setPropertyId(e.target.value);
        setTenantId('');
        setSelectedFloor('');
        setReportData([]);
        setCurrentPage(0);
        setSelectedTenants([]);
    };


    const handleTenantChange = (e) => {
        const { value, checked } = e.target;

        setSelectedTenants((prev) => {
            if (checked) {
                // Add if not already there
                if (prev.includes(value)) return prev;
                return [...prev, value];
            } else {
                // Remove if unchecked
                return prev.filter((item) => item !== value);
            }
        });

        setReportData([]);
        setCurrentPage(0);
    };


    const getPreviousMonth = () => {
        const d = new Date();
        d.setMonth(d.getMonth() - 1);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    };

    const [selectedMonth, setSelectedMonth] = useState(getPreviousMonth());

    const getMonth = () => selectedMonth ? Number(selectedMonth.split("-")[1]) : null;
    const getYear = () => selectedMonth ? Number(selectedMonth.split("-")[0]) : null;

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    //const offset = currentPage * itemsPerPage;
    const pageCount = Math.ceil(ReportData.length / itemsPerPage);



    const sortedReportData = React.useMemo(() => {
        let sortableData = [...ReportData];
        if (sortConfig.key !== '') {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [ReportData, sortConfig]);

    const currentPageData = sortedReportData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = key => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'asc') {
                return <FontAwesomeIcon icon={faSortUp} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
            if (sortConfig.direction === 'desc') {
                return <FontAwesomeIcon icon={faSortDown} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
        }

    };


    const propertyName =
        property_id
            ? properties.find(p => p._id === property_id)?.property_name || 'All'
            : 'All';

    const tenantNames =
        selectedTenants.length > 0
            ? selectedTenants
                .map(id => allTenants.find(t => t._id === id)?.tenant_store_name)
                .filter(Boolean)
                .join(', ')
            : 'All';

    const formatMonthYear = (ym) => {
        const [year, month] = ym.split("-");
        return new Date(year, month - 1).toLocaleString("en-US", {
            month: "long",
            year: "numeric"
        });
    };

    const auditPeriodLabel = formatMonthYear(selectedMonth);

    const handleExport = (format) => {
        if (ReportData.length > 0) {
            if (format === 'excel') {
                exportToExcel();
                insertToLog(" exported Audit report to excel");
            } else if (format === 'pdf') {
                exportToPDF();
                insertToLog(" exported Audit report to pdf")
            }
        }
    };


    const exportToExcel = () => {
        const worksheet = XLSX.utils.aoa_to_sheet([]);

        /* ================= TITLE ================= */
        XLSX.utils.sheet_add_aoa(worksheet, [['Tenant Audit Report']], { origin: 'A1' });
        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: REPORT_COLUMNS.length - 1 } }
        ];

        /* ================= METADATA ================= */
        const metadata = [
            ['Audit Period', auditPeriodLabel],
            ['Property', propertyName],
            ['Tenant(s)', tenantNames],
            ['Exported By', login_name],
            ['Exported On', new Date().toLocaleString()]
        ];

        XLSX.utils.sheet_add_aoa(worksheet, metadata, { origin: 'A2' });

        /* ================= HEADERS ================= */
        const headers = REPORT_COLUMNS.map(col => col.label);
        const startRow = metadata.length + 3;

        XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: `A${startRow}` });

        /* ================= DATA ================= */
        const rows = ReportData.map(row =>
            REPORT_COLUMNS.map(col => row[col.key] ?? '')
        );

        XLSX.utils.sheet_add_aoa(worksheet, rows, {
            origin: `A${startRow + 1}`
        });

        /* ================= AUTO COLUMN WIDTH ================= */
        const colWidths = REPORT_COLUMNS.map((col, colIndex) => {
            const maxLength = Math.max(
                col.label.length,
                ...ReportData.map(row =>
                    row[col.key] ? row[col.key].toString().length : 0
                )
            );

            return {
                wch: col.format === 'number'
                    ? Math.min(maxLength + 2, 18)   // numbers compact
                    : Math.min(maxLength + 4, 40)   // text readable
            };
        });

        worksheet['!cols'] = colWidths;

        /* ================= SAVE ================= */
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Audit Report');
        XLSX.writeFile(workbook, 'TenantAuditReport.xlsx');
    };

    const exportToPDF = () => {
        const doc = new jsPDF('l', 'pt', 'a4'); // landscape

        /* ================= TITLE ================= */
        doc.setFontSize(14);
        doc.text('Tenant Audit Report', 40, 30);

        /* ================= METADATA ================= */
        doc.setFontSize(9);
        const meta = [
            `Audit Period: ${auditPeriodLabel}`,
            `Property: ${propertyName}`,
            `Tenant(s): ${tenantNames}`,
            `Exported By: ${login_name}`,
            `Exported On: ${new Date().toLocaleString()}`
        ];

        meta.forEach((m, i) => doc.text(m, 40, 50 + i * 12));

        /* ================= TABLE DATA ================= */
        const tableBody = ReportData.map(row =>
            REPORT_COLUMNS.map(col => row[col.key] ?? '')
        );

        /* ================= COLUMN WIDTH LOGIC ================= */
        const columnStyles = REPORT_COLUMNS.reduce((acc, col, index) => {
            acc[index] = {
                cellWidth: col.format === 'number' ? 60 : 'auto'
            };
            return acc;
        }, {});

        /* ================= TABLE ================= */
        doc.autoTable({
            startY: 120,
            head: [REPORT_COLUMNS.map(col => col.label)],
            body: tableBody,

            tableWidth: 'auto',
            styles: {
                fontSize: 8,
                cellPadding: 4,
                cellWidth: 'wrap',
                overflow: 'linebreak'
            },

            columnStyles,
            headStyles: { fillColor: [0, 71, 178], textColor: 255, fontSize: 6, fontStyle: 'bold' },

            theme: 'grid'
        });

        /* ================= SAVE ================= */
        doc.save('TenantAuditReport.pdf');
    };



    const reset = () => {
        setStartDate('')
        setEndDate('')
        setPropertyId('');
        setCategoryId('');
        setSubcategoryId('');
        setGroupName('');
        setTenantId('');
        setSelectedFloor('');
        setSelectedTenants([]);
        setSearchTenant('');
        setDropdownOpen(false);
        setReportData([])
        setMonthError('');
    }

    return (
        <Fragment>
            <Form className='theme-form' onSubmit={generateReport}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label>Audit Period</Label>
                                    <input
                                        type="month"
                                        className="form-control"
                                        value={selectedMonth}
                                        max={getPreviousMonth()}
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                    />
                                    {monthError && (
                                        <div
                                            style={{ position: "absolute", top: "70px", left: "3", color: "red", fontSize: "12px" }}
                                        >
                                            {monthError}
                                        </div>
                                    )}
                                </FormGroup>
                            </Col>

                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Property</Label>
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">All</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <div style={{ position: 'relative', width: '100%' }} ref={dropdownRef}>
                                    <label>Tenants</label>
                                    <div
                                        onClick={toggleDropdown}
                                        style={{
                                            border: '1px solid #ccc',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>Select Tenants</div>
                                        <span style={{ marginLeft: 'auto' }}>&#9662;</span>
                                    </div>
                                    {dropdownOpen && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: '#fff',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                marginTop: '4px',
                                                zIndex: 1,
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '250px', // Set the maximum height for the dropdown
                                                overflowY: 'auto' // Scrollable content
                                            }}
                                        >
                                            {/* Search Bar */}
                                            <div style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search tenants..."
                                                    value={searchTenant}
                                                    onChange={(e) => setSearchTenant(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '6px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>

                                            {/* Filtered Tenants List */}
                                            {filteredTenants.length > 0 ? (
                                                filteredTenants.map(tenant => (
                                                    <label
                                                        key={tenant._id}
                                                        style={{ display: 'block', padding: '8px', cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={tenant._id}
                                                            checked={selectedTenants.includes(tenant._id)}
                                                            onChange={handleTenantChange}
                                                            style={{ marginRight: '8px' }}
                                                        />

                                                        {/* 👇 Display code + name */}
                                                        <span style={{ fontWeight: 500 }}>
                                                            {tenant.tenant_store_name}
                                                            {tenant.tenant_code ? ` - ${tenant.tenant_code}` : ""}
                                                        </span>
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: 'gray', textAlign: 'center' }}>
                                                    No results found
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Col >
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }} >Generate Report</Btn>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: reset }} >Reset</Btn>
                            </Col>

                        </Row>


                    </CardBody>
                </Card>
            </Form>
            {loading === true ? (
                <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-3' }} />
                </div>

            ) : (
                <Card>
                    <CardHeader>
                        <Row className="justify-content-end">
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('excel'),
                                        onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                </Btn>
                                {tooltip === 'Export to Excel' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col>
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('pdf'),
                                        onMouseEnter: () => handleMouseEnter('Export to PDF'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFilePdf} size="lg" />
                                </Btn>
                                {tooltip === 'Export to PDF' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Col sm="12" lg="12" xl="12">
                            <div className="table-responsive" >
                                <Table
                                    style={{ tableLayout: 'auto', whiteSpace: 'nowrap' }}>
                                    <thead>
                                        <tr>
                                            {REPORT_COLUMNS.map(col => (
                                                <th
                                                    key={col.key}
                                                    onClick={() => requestSort(col.key)}
                                                    style={
                                                        col.key === "audit_comments" || col.key === "discrepancy_remarks"
                                                            ? { minWidth: "450px", maxWidth: "450px" }
                                                            : {}
                                                    }
                                                >
                                                    {col.label}
                                                    {getSortIcon(col.key)}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPageData.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={REPORT_COLUMNS.length}
                                                    style={{ textAlign: "center", padding: "20px" }}
                                                >
                                                    No data found
                                                </td>
                                            </tr>
                                        ) : (
                                            currentPageData.map((row, index) => (
                                                <tr key={index}>
                                                    {REPORT_COLUMNS.map(col => (
                                                        <td
                                                            key={col.key}
                                                            style={
                                                                col.key === "audit_comments" || col.key === "discrepancy_remarks"
                                                                    ? {
                                                                        minWidth: "450px",
                                                                        maxWidth: "450px",
                                                                        whiteSpace: "normal",
                                                                        wordBreak: "break-word"
                                                                    }
                                                                    : {}
                                                            }
                                                        >
                                                            {col.format === 'number'
                                                                ? (row[col.key] ?? 0).toLocaleString(undefined, {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })
                                                                : row[col.key] || ''}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            {ReportData.length > 50 && (
                                <ReactPaginate
                                    previousLabel={'<<'}
                                    nextLabel={'>>'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                />
                            )}
                        </Col>
                    </CardBody>
                </Card>
            )}
        </Fragment>
    );
};

export default TenantAuditReportView;
